/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReference_viewer = {
    readonly isItemInvoiceEnabled: boolean | null;
    readonly " $refType": "PdpSharedDetailReference_viewer";
};
export type PdpSharedDetailReference_viewer$data = PdpSharedDetailReference_viewer;
export type PdpSharedDetailReference_viewer$key = {
    readonly " $data"?: PdpSharedDetailReference_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetailReference_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isItemInvoiceEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "INVOICE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"INVOICE\")"
    }
  ]
};
(node as any).hash = '0e28fc50ce37d3cf6e5dff753ecc8480';
export default node;
